import comp from "./TagLearningGoalsListWrapper";
export default comp;
